import React from "react";
import DetailWrapper from "../../../components/detailWrapper";
import CloseDetailPage from "../../../components/CloseComponent/CloseDetailPage";
import { useNavigate } from "react-router";
import { HiChevronLeft } from "react-icons/hi";
import { BsShieldFillCheck } from "react-icons/bs";
import { Button } from "semantic-ui-react";
import { useTranslation } from "react-i18next";

const UserSecureVerity = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`settings.${key}`);
  const i18n_common = (key) => t(`common.${key}`);
  const navigate = useNavigate();
  return (
    <DetailWrapper
      closeAnimate
      wrapperClassName={`h-full w-full md:absolute fixed top-0 left-0 max-h-full z-[1] bg-gradient-to-br`}
    >
      <CloseDetailPage
        hasPrev={
          <HiChevronLeft
            className="cursor-pointer"
            onClick={() => navigate(-1)}
          />
        }
        title={i18n("userSecureVerity")}
      />
      <article className="flex flex-col gap-[15px] p-[15px] text-transaction-text dark:text-base-light-white font-medium pt-[50px]">
        <div className="flex items-center justify-center relative mb-[40px]">
          <div className="absolute absolute-center w-[100px] h-[100px] bg-green-500 opacity-[0.15] rounded-full"></div>
          <BsShieldFillCheck className="text-green-500 text-5xl" />
        </div>
        <div className="flex items-center justify-center">
          <span className="text-2xl text-transaction-text dark:text-base-light-white text-2xl">
            {i18n("userSecureVerity")}{" "}
          </span>
        </div>
        <div className="flex flex-col items-center justify-center text-light-gray">
          <span>{i18n("secureVerityHint.1")}</span>
          <br />
          <span>{i18n("secureVerityHint.2")}</span>
        </div>
        <Button
          type="button"
          onClick={() => {
            navigate(-1);
          }}
          content={i18n_common("iKnow")}
          size="xl"
          className="!bg-main-color !text-white !w-full !py-[17px] !mt-[20px]"
        />
      </article>
    </DetailWrapper>
  );
};

export default UserSecureVerity;
